import { render } from "./EvolutionArrow.vue?vue&type=template&id=6236ef36&scoped=true"
import script from "./EvolutionArrow.vue?vue&type=script&lang=js"
export * from "./EvolutionArrow.vue?vue&type=script&lang=js"

import "./EvolutionArrow.vue?vue&type=style&index=0&id=6236ef36&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6236ef36"]])

export default __exports__